import React from 'react';
import Modal from '../utils/Modal/Modal';
import UserListItem from '../UserListItem/UserListItem';
import styles from './SongPage.module.scss';

const LikersModal = ({
  showLikers,
  setShowLikers,
  likersDetails,
  isLoading = false,
  hasError = false,
  onRetry,
  handleUserPageNavFromSong,
}) =>
  showLikers ? (
    <Modal
      show={showLikers}
      onClose={() => setShowLikers(false)}
      size="small"
      title="Likers"
    >
      <div className={styles.likersList}>
        {isLoading && likersDetails.length === 0 && (
          <p className={styles.likersStatusText}>Loading...</p>
        )}
        {!isLoading && hasError && (
          <p className={styles.likersStatusText}>
            Couldn't load everyone who liked this.{' '}
            <button
              type="button"
              className={styles.likersRetryButton}
              onClick={onRetry}
            >
              Retry
            </button>
          </p>
        )}
        {!isLoading && !hasError && likersDetails.length === 0 && (
          <p className={styles.likersStatusText}>No likes yet.</p>
        )}
        {likersDetails.map((userDetail, index) => (
          <UserListItem
            key={index}
            user={userDetail}
            handleUserPageNavFromSong={handleUserPageNavFromSong}
            onCloseModal={() => setShowLikers(false)}
          />
        ))}
      </div>
    </Modal>
  ) : null;

export default LikersModal;
